import React from "react";
import {
  BaseEdge,
  getSmoothStepPath,
  EdgeLabelRenderer,
  EdgeProps,
  useReactFlow,
} from "reactflow";
import { handleUpdateEdge } from "../../service/StakeRelationService"; // your backend func
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
export default function CustomDeletableEdge(props: EdgeProps) {
  const { id, sourceX, sourceY, targetX, targetY, markerEnd, data } = props;
  const { setEdges, setNodes, getNodes } = useReactFlow();

  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  const onDelete = async () => {
    // Remove edge from state
    setEdges((eds) => eds.filter((e) => e.id !== id));

    // Update child node's PARENT_STAKE_ID locally
    const targetNodeId = props.target;
    setNodes((nds) =>
      nds.map((node) =>
        node.id === targetNodeId
          ? { ...node, data: { ...node.data, PARENT_STAKE_ID: 0 } }
          : node
      )
    );

    // Call backend if relationUID exists
    const relationUID = data?.relationUID || Number(id.split("-")[1]);
    if (relationUID) {
      try {
        await handleUpdateEdge(relationUID);
      } catch (err) {
        console.error("Failed to update parent:", err);
      }
    }
  };

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} />

      <EdgeLabelRenderer>
        <div
          style={{
            padding: "5px",
            background:'#fff',
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
          }}
        >
          <div
            onClick={onDelete}
            style={{
              height: 22,
              width: 22,
              background: "#f5f7faff",
              borderRadius: "50%",
              // border: "1px solid #dcdcdc",
              boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
              cursor: "pointer",
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              pointerEvents: "all",
              padding: "13px",
            }}
          >
            <CloseOutlinedIcon style={{ color: "#b1b1b7" }} />
          </div>
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
